
import { initializeApp,getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseReview = {
  apiKey: process.env.REACT_APP_FIREBASE_REVIEW_KEY,
  authDomain: "reviews-e182c.firebaseapp.com",
  projectId: "reviews-e182c",
  storageBucket: "reviews-e182c.firebasestorage.app",
  messagingSenderId: "117702972554",
  appId: process.env.REACT_APP_FIREBASE_REVIEW_ID,
};

const reviewApp =
  getApps().find(app => app.name === 'appReview') ||
  initializeApp(firebaseReview, 'appReview');

export const dbReview = getFirestore(reviewApp);


